/* =============================================================================
   Night Operators PVS-14 , static landing page behaviour
   Plain vanilla JS. No framework, no build step, no postMessage bridge.
   Pair with: pvs14-lander.html + pvs14-lander.css
   Everything is scoped to #no-pvs14 and namespaced inside one IIFE.
   ============================================================================= */
(function () {
  "use strict";

  var ROOT = document.getElementById("no-pvs14");
  if (!ROOT) return;

  var CDN = "https://nightoperators-pvs-14.lovable.app";

  /* ---------------------------------------------------------------------------
     0. Tiny helpers
     ------------------------------------------------------------------------ */
  function $(sel, ctx) { return (ctx || ROOT).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || ROOT).querySelectorAll(sel)); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function fmt(n) {
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  var CHECK_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" ' +
    'class="lucide lucide-check w-4 h-4 mt-0.5 text-accent flex-shrink-0"><path d="M20 6 9 17l-5-5"></path></svg>';

  /* ---------------------------------------------------------------------------
     1. Shopify variant map + direct /cart/add.js
     ------------------------------------------------------------------------ */
  var VARIANTS = {
    // PVS-14 KIT , STANDARD housing
    "kit-no-pvs14-STANDARD-1250-1350": "50651618672886",
    "kit-no-pvs14-STANDARD-1400-1550": "50748972531958",
    "kit-no-pvs14-STANDARD-1600-1750": "50861859799286",
    "kit-no-pvs14-STANDARD-1800-2000": "50748972564726",
    // PVS-14 KIT , PRO housing
    "kit-no-pvs14-PRO-1250-1350": "50652605907190",
    "kit-no-pvs14-PRO-1400-1550": "50748972663030",
    "kit-no-pvs14-PRO-1600-1750": "50861859864822",
    "kit-no-pvs14-PRO-1800-2000": "50748972695798",
    // PVS-14 & HEAT BRIDGE , STANDARD housing
    "kit-no-pvs14-heat-bridge-STANDARD-1250-1350": "50651618771190",
    "kit-no-pvs14-heat-bridge-STANDARD-1400-1550": "50748972597494",
    "kit-no-pvs14-heat-bridge-STANDARD-1600-1750": "50861859832054",
    "kit-no-pvs14-heat-bridge-STANDARD-1800-2000": "50748972630262",
    // PVS-14 & HEAT BRIDGE , PRO housing
    "kit-no-pvs14-heat-bridge-PRO-1250-1350": "50652605939958",
    "kit-no-pvs14-heat-bridge-PRO-1400-1550": "50748972728566",
    "kit-no-pvs14-heat-bridge-PRO-1600-1750": "50861859897590",
    "kit-no-pvs14-heat-bridge-PRO-1800-2000": "50748972761334",
    // PVS-31 PRO dual-tube binocular (FOM only , no housing variant)
    "kit-no-pvs31-pro-1400-1550": "50751937872118",
    "kit-no-pvs31-pro-1600-1800": "50751937904886",
    "kit-no-pvs31-pro-1800-1950": "51017700999414",
    "kit-no-pvs31-pro-2000-2100": "50752033161462",
    // Add-on , Gen II FAST SF vented helmet (colour + size)
    "addon-helmet-blk-m": "51760827728118",
    "addon-helmet-blk-l": "51760827760886"
  };

  function addToCart(items, onDone) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : "Add to cart failed");
        document.dispatchEvent(new CustomEvent("no-pvs14:added", { detail: res.body }));
        if (onDone) onDone(null, res.body);
        // Refresh whatever cart UI the theme uses, then fall back to /cart.
        if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        if (window.noCartDrawerOpen) { window.noCartDrawerOpen(res.body); } else { window.location.href = "/cart"; }
      })
      .catch(function (err) {
        if (onDone) onDone(err);
        window.console && console.error("[no-pvs14] add to cart:", err);
      });
  }

  /* ---------------------------------------------------------------------------
     2. Buy-box data (mirrors the source of truth 1:1)
     ------------------------------------------------------------------------ */
  var PRO_UPCHARGE = 35;
  var HELMET_PRICE = 149.95;

  var FOM_EXPLAINER = {
    "1250-1350": "Entry-level clarity. Clean image, no blems. Best value for first-time NV users.",
    "1400-1550": "Mid-tier performance. Sharper edge-to-edge clarity. Recommended for most operators.",
    "1600-1750": "Upper mid-premium Gen 2+ tubes. Enhanced resolution and light gathering for serious operators.",
    "1800-2000": "High-tier clarity. Excellent resolution and light gathering. Great for demanding conditions.",
    "1600-1800": "Upper mid-premium Gen 2+ tubes. Enhanced resolution and light gathering for serious operators.",
    "1800-1950": "High-tier clarity. Excellent resolution and light gathering. Great for demanding conditions.",
    "2000-2100": "Top-tier Gen 2+ performance. Maximum resolution and light gathering for the most demanding operators."
  };
  var HOUSING_EXPLAINER = {
    STANDARD: "Classic milspec PVS-14 form factor. 40\u00b0 FOV. Recognizable, accessory-tested.",
    PRO: "Refined housing. 50\u00b0 FOV (+10\u00b0), lighter, more compact. Same tube, same accessories."
  };

  var IMG = {
    kitStd: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/nospeed-1023-kit-pvs14-standalone-7e4dabd4.webp?v=1792743297",
    kitStdPro: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/nospeed-1023-kit-pvs14-standalone-pro-6e0c741c.webp?v=1792743219",
    kitHeat: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/nospeed-1023-kit-pvs14-heat-bridge-c0ba4518.webp?v=1792743184",
    kitHeatPro: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/nospeed-1023-kit-pvs14-heat-bridge-pro-e1587def.webp?v=1792743255",
    helmetBlk: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-blk.webp?v=1792014202",
    helmetBlk2: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-detail.webp?v=1792014232",
    helmetTan: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-tan.webp?v=1792014222",
    helmetRg: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-rg-nc1019.webp?v=1792014212"
  };

  var BUNDLES = [
    {
      kitId: "no-pvs14",
      name: "NIGHT OPERATORS PVS-14",
      shortName: "Standalone PVS-14",
      totalPrice: 1749.95,
      hasHousing: true,
      image: IMG.kitStd,
      imagePro: IMG.kitStdPro,
      cta: "Get The Night Operators PVS-14",
      ctaPro: "Get The Night Operators PVS-14 PRO",
      fomOptions: ["1250-1350", "1400-1550", "1600-1750", "1800-2000"],
      fomUpcharge: { "1250-1350": 0, "1400-1550": 100, "1600-1750": 550, "1800-2000": 700 },
      compareAt: {
        "STANDARD-1250-1350": 4495.95, "STANDARD-1400-1550": 4789.95,
        "STANDARD-1600-1750": 5749.95, "STANDARD-1800-2000": 5989.95,
        "PRO-1250-1350": 4659.95, "PRO-1400-1550": 4859.95,
        "PRO-1600-1750": 5839.95, "PRO-1800-2000": 6059.95
      },
      defaultFom: "1400-1550",
      variantKey: function (h, f) { return "kit-no-pvs14-" + h + "-" + f; }
    },
    {
      kitId: "no-pvs14-heat-bridge",
      name: "NIGHT OPERATORS PVS-14 + HEAT BRIDGE",
      shortName: "Heat Bridge",
      totalPrice: 2249.95,
      hasHousing: true,
      image: IMG.kitHeat,
      imagePro: IMG.kitHeatPro,
      cta: "Get The Bridge",
      ctaPro: "Get The Bridge PRO",
      fomOptions: ["1250-1350", "1400-1550", "1600-1750", "1800-2000"],
      fomUpcharge: { "1250-1350": 0, "1400-1550": 100, "1600-1750": 550, "1800-2000": 700 },
      compareAt: {
        "STANDARD-1250-1350": 5589.95, "STANDARD-1400-1550": 5789.95,
        "STANDARD-1600-1750": 6989.95, "STANDARD-1800-2000": 7389.95,
        "PRO-1250-1350": 5659.95, "PRO-1400-1550": 5859.95,
        "PRO-1600-1750": 7049.95, "PRO-1800-2000": 7459.95
      },
      defaultFom: "1400-1550",
      variantKey: function (h, f) { return "kit-no-pvs14-heat-bridge-" + h + "-" + f; }
    },
    {
      kitId: "no-pvs31-pro",
      name: "NIGHT OPERATORS PVS-31 PRO",
      shortName: "PVS-31 PRO",
      totalPrice: 3799.95,
      hasHousing: false,
      cta: "Get The PVS-31 PRO",
      fomOptions: ["1400-1550", "1600-1800", "1800-1950", "2000-2100"],
      fomUpcharge: { "1400-1550": 0, "1600-1800": 650, "1800-1950": 1150, "2000-2100": 1600 },
      compareAt: { "1400-1550": 7599.0, "1600-1800": 10399.95, "1800-1950": 10599.95, "2000-2100": 10799.95 },
      defaultFom: "1400-1550",
      variantKey: function (_h, f) { return "kit-no-pvs31-pro-" + f; }
    }
  ];

  /* WHICH TIERS CANNOT BE BOUGHT, READ OFF THE PAGE'S OWN SHOPIFY DATA.

     This used to be a hand written list saying the 1250-1350 tier was sold out
     in BOTH housings on both PVS-14 cards. That went stale: the STANDARD 1250
     variants were removed from Shopify, but the PRO 1250 kit is buyable and is
     held at the US warehouse, and this card was refusing it.

     The theme already prints every variant of THIS product, with its
     availability, as window.vtlsLiquidData.product. That is the same data the
     buy box reads, so reading it here is what keeps this card and the buy box
     from disagreeing on a day stock changes. Nothing new is fetched.

     Three cases, in this order:
       1. the tier has no variant in the map at all       -> cannot be bought
       2. the page printed that variant                   -> trust the page
       3. the page did not (the PVS-31 card on a PVS-14
          page, or a theme that printed nothing)          -> the hand list
     Case 3 is the old behaviour, so the worst this can do is what it did
     before. */
  var LIVE_AVAIL = (function () {
    var map = null;
    try {
      var p = window.vtlsLiquidData && window.vtlsLiquidData.product;
      var vs = p && p.variants;
      if (vs && vs.length) {
        map = {};
        for (var i = 0; i < vs.length; i++) map[String(vs[i].id)] = vs[i].available === true;
      }
    } catch (e) { map = null; }
    return map;
  })();

  /* round 4 (14 Oct 2026): this template no longer prints window.vtlsLiquidData, so LIVE_AVAIL stayed null and the
     hand list below marked the in stock PRO 1250-1350 kit as sold out on the dark cards. Read the two products' own
     .js once instead and repaint the cards; until it answers, the old behaviour stands. */
  if (!LIVE_AVAIL) {
    try {
      Promise.all(["/products/pvs-14-night-vision-monocular.js", "/products/pvs-31-pro-night-vision-binocular.js"].map(function (u) {
        return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        var map = {}, n = 0;
        ps.forEach(function (p) { if (p && p.variants) p.variants.forEach(function (v) { map[String(v.id)] = v.available === true; n++; }); });
        if (n) { LIVE_AVAIL = map; notifyAddons(); }
      });
    } catch (e) {}
  }
  /* 2026-10-22 (Bon, pick 5B: "5B until it sells out then we can move back to
     STD 1400"). THE BUY COLUMN AT THE TOP OF THE PAGE IS THE SOURCE. Its
     server rendered data (script[data-no-buy-data]) carries the opening
     housing and grade, which the theme sets to PRO 1250 while that kit is in
     stock and back to the theme's own pick (STD 1400) the moment it is not,
     plus every variant's availability. The first card here opens on the same
     choice and reads the same availability, so the two boxes never disagree
     and nothing has to be switched back by hand. Only on the main PVS-14
     listing: on any other page this returns null and nothing changes.
     Undo: delete this block, the COLUMN_AVAIL check in isOutOfStock and the
     START block in initBuyBox. */
  var COLUMN_DATA_CACHE;
  function columnData() {
    if (COLUMN_DATA_CACHE !== undefined) return COLUMN_DATA_CACHE;
    COLUMN_DATA_CACHE = null;
    try {
      var s = document.querySelector("script[data-no-buy-data]");
      var d = s ? JSON.parse(s.textContent) : null;
      if (d && d.handle === "pvs-14-night-vision-monocular") COLUMN_DATA_CACHE = d;
    } catch (e) { COLUMN_DATA_CACHE = null; }
    return COLUMN_DATA_CACHE;
  }
  function columnAvail(id) {
    var d = columnData();
    if (!d || !d.variants) return null;
    for (var i = 0; i < d.variants.length; i++) {
      if (String(d.variants[i].id) === String(id)) return d.variants[i].available === true;
    }
    return null;
  }

  // Fallback only. Used for a card whose product this page did not print.
  var OOS_FALLBACK = {
    "no-pvs14": { "1250-1350": true },
    "no-pvs14-heat-bridge": { "1250-1350": true },
    "no-pvs31-pro": { "2000-2100": true }
  };

  function isOutOfStock(b, f, h) {
    var id = VARIANTS[b.variantKey(h || "STANDARD", f)];
    if (!id) return true;
    if (LIVE_AVAIL && Object.prototype.hasOwnProperty.call(LIVE_AVAIL, String(id))) {
      return LIVE_AVAIL[String(id)] !== true;
    }
    var ca = columnAvail(id);
    if (ca !== null) return ca !== true;
    var m = OOS_FALLBACK[b.kitId];
    return !!(m && m[f]);
  }
  function fomUp(b, f) { return b.fomUpcharge[f] || 0; }
  function kitPriceOf(b, h, f) {
    return b.totalPrice + (b.hasHousing && h === "PRO" ? PRO_UPCHARGE : 0) + fomUp(b, f);
  }

  /* Shared add-on state (one helmet selection across all three cards). */
  var addons = { helmet: { selected: false, size: "M", color: "BLK" } };
  function helmetImage() {
    return addons.helmet.color === "TAN" ? IMG.helmetTan
      : addons.helmet.color === "RG" ? IMG.helmetRg
        : IMG.helmetBlk;
  }
  var addonSubscribers = [];
  function notifyAddons() { addonSubscribers.forEach(function (fn) { fn(); }); }

  /* ---------------------------------------------------------------------------
     HELMET SIZE AVAILABILITY (2026-09-19).
     A size that is sold out must never be selectable anywhere a helmet is sold.
     The six ids above are the only helmet variants, so availability is read once
     from the product .js endpoint and every picker on this page consults it.
     Until the answer arrives nothing is greyed: an unknown is never rendered as
     sold out, because a false sold out costs a real sale.
     ------------------------------------------------------------------------ */
  /* round 4 (14 Oct 2026, Bon): we only sell the VENTED helmet now. COLOR-SIZE to variant id, read from the live
     helmet product, VENTED shell only, so a new vented colour or size shows up here by itself once it is in stock. */
  function noVented(p) {
    var out = {}; if (!p || !p.variants) return out;
    var names = (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).toUpperCase(); });
    var iS = names.indexOf("SIZE"), iC = names.indexOf("COLOR"), iH = names.indexOf("SHELL");
    if (iS < 0 || iC < 0 || iH < 0) return out;
    var SZ = { MEDIUM: "M", LARGE: "L" }, CO = { BLACK: "BLK", "RANGER GREEN": "RG", TAN: "TAN" };
    p.variants.forEach(function (v) {
      var o = v.options || [v.option1, v.option2, v.option3];
      if (String(o[iH]).toUpperCase() !== "VENTED") return;
      var z = SZ[String(o[iS]).toUpperCase()], c = CO[String(o[iC]).toUpperCase()];
      if (z && c) out[c + "-" + z] = String(v.id);
    });
    return out;
  }
  var HELMET_HANDLE = "fast-sf-helmet";
  var helmetAvail = null;               // null = not known yet
  var helmetAvailSubs = [];

  function helmetKey(color, size) {
    return "addon-helmet-" + String(color).toLowerCase() + "-" + String(size).toLowerCase();
  }
  /* true when we do not know yet, so the picker stays fully usable on a failed
     read rather than locking the customer out of a helmet we do have. */
  function helmetAvailable(color, size) {
    var id = VARIANTS[helmetKey(color, size)];
    if (!id) return false;
    if (!helmetAvail) return true;
    return helmetAvail[String(id)] !== false;
  }
  function helmetSizeAvailable(size) {
    return ["BLK", "TAN", "RG"].some(function (c) { return helmetAvailable(c, size); });
  }
  function helmetColorAvailable(color) {
    return ["M", "L"].some(function (z) { return helmetAvailable(color, z); });
  }
  /* If the current pick cannot be bought, move to one that can. Size first,
     because size is what Bon asked about and what a customer cares about most. */
  function helmetFixSelection() {
    if (!helmetAvail) return;
    if (!helmetAvailable(addons.helmet.color, addons.helmet.size)) {
      var sizes = ["M", "L"], colors = ["BLK", "TAN", "RG"], i, j;
      for (i = 0; i < sizes.length; i++) {
        if (helmetAvailable(addons.helmet.color, sizes[i])) { addons.helmet.size = sizes[i]; return; }
      }
      for (i = 0; i < sizes.length; i++) {
        for (j = 0; j < colors.length; j++) {
          if (helmetAvailable(colors[j], sizes[i])) {
            addons.helmet.size = sizes[i]; addons.helmet.color = colors[j]; return;
          }
        }
      }
    }
  }
  /* Paint one group of option pills against availability. */
  function helmetPaintOpts(opts) {
    if (!opts) return;
    $$("[data-color]", opts).forEach(function (b) {
      var c = b.getAttribute("data-color");
      var ok = helmetColorAvailable(c);
      b.disabled = !ok;
      b.style.display = ok ? "" : "none";
      b.setAttribute("aria-disabled", ok ? "false" : "true");
      if (!ok) {
        b.className = CLS.segOff + " opacity-50 line-through cursor-not-allowed";
        b.title = "Sold out";
      } else {
        b.className = c === addons.helmet.color ? CLS.segOn : CLS.segOff;
        b.removeAttribute("title");
      }
    });
    $$("[data-size]", opts).forEach(function (b) {
      var z = b.getAttribute("data-size");
      var ok = helmetSizeAvailable(z) && helmetAvailable(addons.helmet.color, z);
      b.disabled = !ok;
      b.style.display = ok ? "" : "none";
      b.setAttribute("aria-disabled", ok ? "false" : "true");
      var base = b.getAttribute("data-size-label") || b.textContent;
      if (!b.getAttribute("data-size-label")) b.setAttribute("data-size-label", base);
      if (!ok) {
        b.className = CLS.segOff + " opacity-50 line-through cursor-not-allowed";
        b.textContent = base;
        b.title = "Sold out";
      } else {
        b.className = z === addons.helmet.size ? CLS.segOn : CLS.segOff;
        b.textContent = base;
        b.removeAttribute("title");
      }
    });
  }
  /* True when the currently chosen helmet cannot be added to a cart. */
  function helmetPickBlocked() {
    return !helmetAvailable(addons.helmet.color, addons.helmet.size);
  }
  /* round 4: true only when the stock read is in and no vented helmet is left; the row then hides. */
  function helmetNoneLeft() {
    if (!helmetAvail) return false;
    return !["BLK", "TAN", "RG"].some(function (c) { return helmetColorAvailable(c); });
  }

  /* ---------------------------------------------------------------------------
     NGAL ADD ON ROW (lane NGAL-UPSELLS-2, 2026-09-19)
     Bon: "add the NGAL onto the PVS14 and PVS31 pages as well."

     ONE SELECTION SHARED ACROSS ALL THREE KIT CARDS, exactly like the helmet
     above it, so a shopper who ticks the NGAL on one card and scrolls to another
     sees the same answer rather than two disagreeing rows.

     IT FAILS CLOSED, AND THAT IS THE OPPOSITE DEFAULT FROM THE HELMET READ ABOVE.
     /products/ngal-ir-laser-illuminator.js answers 404 outside the United States,
     because the NGAL sits in the SNAPL delivery profile whose only zone is the US
     and it is excluded from the other markets' catalogs. Up there an unknown
     answer leaves every size SELECTABLE, because a false sold out costs a real
     sale. Down here an unknown answer means we do not know this shopper may buy
     it at all, so a 404, a network failure or a malformed answer all leave the
     row UNBUILT and the page exactly as it was.

     A SOLD OUT COLOUR GREYS, THE ROW STAYS (rulebook-product-facts-and-policy
     section 1b). The row is never removed for a stock out.

     THE PRICE IS NEVER TYPED. Every figure comes from the variant the feed
     returned, so there is no NGAL price constant in this file on purpose.
     ------------------------------------------------------------------------ */
  var NGAL_HANDLE = "ngal-ir-laser-illuminator";
  var ngal = { ready: false, variants: [], color: null, selected: false, title: "", image: "" };

  function ngalMoney(cents) {
    var n = Number(cents);
    if (!n) return 0;
    return n > 500 ? n / 100 : n;
  }
  function ngalVariant(color) {
    var want = String(color === undefined ? ngal.color : color);
    for (var i = 0; i < ngal.variants.length; i++) {
      if (String(ngal.variants[i].option1) === want) return ngal.variants[i];
    }
    return null;
  }
  function ngalColorAvailable(color) {
    var v = ngalVariant(color);
    return !!(v && v.available);
  }
  function ngalPrice() {
    var v = ngalVariant();
    return v ? ngalMoney(v.price) : 0;
  }
  /* True when the currently chosen NGAL cannot be added to a cart. */
  function ngalPickBlocked() {
    return !ngalColorAvailable(ngal.color);
  }
  /* Never leave the shopper holding a colour that cannot be bought. */
  function ngalFixSelection() {
    if (!ngal.variants.length || !ngalPickBlocked()) return;
    for (var i = 0; i < ngal.variants.length; i++) {
      if (ngal.variants[i].available) { ngal.color = String(ngal.variants[i].option1); return; }
    }
  }
  function ngalImage() {
    var v = ngalVariant();
    if (v && v.featured_image && v.featured_image.src) return v.featured_image.src;
    return ngal.image;
  }

  /* Build one NGAL row inside a card's COMPLETE YOUR SETUP group, directly after
     the helmet row, in the helmet row's own markup so the two read as one group
     (section 1b: an add on joins the group already on the page, in that group's
     own markup). Returns the row, or null when there is nowhere to put it. */
  function ngalBuildRow(group) {
    if (!group || group.querySelector("[data-no-ngal-row]")) return null;

    var row = el("div", "flex items-start gap-3 py-3 border-t border-border/40 first:border-t-0 transition-colors -mx-2 px-2 rounded-sm");
    row.setAttribute("data-no-ngal-row", "");

    var sw = el("button", "mt-0.5 relative shrink-0 w-10 h-5 rounded-full border transition-colors border-border-bright bg-background/60 hover:border-accent");
    sw.type = "button";
    sw.setAttribute("role", "switch");
    sw.setAttribute("aria-checked", "false");
    sw.setAttribute("aria-label", "Add NGAL IR/VIS laser");
    sw.setAttribute("data-no-ngal-toggle", "");
    var knob = el("span", "absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full transition-all left-[3px] bg-muted-foreground");
    knob.setAttribute("data-no-ngal-knob", "");
    sw.appendChild(knob);
    row.appendChild(sw);

    var imgWrap = el("div", "shrink-0 w-12 h-12 sm:w-14 sm:h-14 aspect-square flex items-center justify-center overflow-hidden");
    var img = el("img", "w-full h-full object-contain");
    img.setAttribute("data-no-ngal-thumb", "");
    img.setAttribute("loading", "lazy");
    img.alt = ngal.title || "NGAL IR/VIS laser";
    if (ngalImage()) img.src = ngalImage();
    imgWrap.appendChild(img);
    row.appendChild(imgWrap);

    var textCol = el("div", "flex-1 min-w-0 text-left");
    var head = el("div", "flex items-baseline justify-between gap-2 flex-wrap");
    var title = el("span", "mono text-[12px] tracking-[0.1em] uppercase break-words min-w-0 text-foreground", "NGAL IR/VIS LASER");
    title.setAttribute("data-no-ngal-title", "");
    var price = el("span", "mono text-[12px] tracking-[0.06em] shrink-0 text-muted-foreground");
    price.setAttribute("data-no-ngal-price", "");
    head.appendChild(title);
    head.appendChild(price);
    textCol.appendChild(head);
    textCol.appendChild(el("p", "text-[12px] leading-[1.4] text-muted-foreground mt-0.5",
      "Rail mounted and live fire recoil rated. Infrared and visible aiming beams."));

    var opts = el("div", "mt-2 flex flex-wrap items-center gap-1.5");
    opts.setAttribute("data-no-ngal-opts", "");
    opts.addEventListener("click", function (e) { e.stopPropagation(); });
    ngal.variants.forEach(function (v) {
      var c = String(v.option1);
      var b = el("button", CLS.segOff, c);
      b.type = "button";
      b.setAttribute("data-no-ngal-color", c);
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        if (!ngalColorAvailable(c)) return;
        ngal.color = c;
        notifyAddons();
      });
      opts.appendChild(b);
    });
    textCol.appendChild(opts);
    row.appendChild(textCol);

    sw.addEventListener("click", function (e) {
      e.stopPropagation();
      /* never turn it on while the chosen colour cannot be bought */
      if (!ngal.selected && ngalPickBlocked()) return;
      ngal.selected = !ngal.selected;
      notifyAddons();
    });

    group.appendChild(row);
    return row;
  }

  /* Paint one card's NGAL row. Called from that card's add on subscriber, so it
     repaints with everything else. */
  function ngalPaintRow(row) {
    if (!row) return;
    var sel = ngal.selected && !ngalPickBlocked();
    var sw = row.querySelector("[data-no-ngal-toggle]");
    if (sw) {
      sw.setAttribute("aria-checked", sel ? "true" : "false");
      sw.className = "mt-0.5 relative shrink-0 w-10 h-5 rounded-full border transition-colors " +
        (sel ? "border-accent bg-accent/30" : "border-border-bright bg-background/60 hover:border-accent");
      var knob = sw.querySelector("[data-no-ngal-knob]");
      if (knob) {
        knob.className = "absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full transition-all " +
          (sel ? "left-[calc(100%-1.125rem)] bg-accent shadow-[0_0_8px_hsl(var(--accent)/0.7)]" : "left-[3px] bg-muted-foreground");
      }
    }
    var t = row.querySelector("[data-no-ngal-title]");
    if (t) t.className = "mono text-[12px] tracking-[0.1em] uppercase break-words min-w-0 " + (sel ? "text-accent" : "text-foreground");
    var p = row.querySelector("[data-no-ngal-price]");
    if (p) {
      p.className = "mono text-[12px] tracking-[0.06em] shrink-0 " + (sel ? "text-accent" : "text-muted-foreground");
      p.textContent = "+" + fmt(ngalPrice());
    }
    var im = row.querySelector("[data-no-ngal-thumb]");
    if (im && ngalImage()) im.src = ngalImage();
    $$("[data-no-ngal-color]", row).forEach(function (b) {
      var c = b.getAttribute("data-no-ngal-color");
      var ok = ngalColorAvailable(c);
      b.disabled = !ok;
      b.setAttribute("aria-disabled", ok ? "false" : "true");
      if (!ok) {
        b.className = CLS.segOff + " opacity-50 line-through cursor-not-allowed";
        b.title = "Sold out";
      } else {
        b.className = c === ngal.color ? CLS.segOn : CLS.segOff;
        b.removeAttribute("title");
      }
    });
  }

  /* Read the NGAL once. A 404 (any shopper outside the US) leaves every row
     unbuilt and the page untouched. */
  var ngalReadySubs = [];
  (function loadNgal() {
    try {
      fetch("/products/" + NGAL_HANDLE + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.variants || !j.variants.length) return;
          ngal.variants = j.variants.filter(function (v) { return v && v.id; });
          if (!ngal.variants.length) return;
          ngal.title = j.title || "";
          ngal.image = j.featured_image || "";
          ngal.color = String(ngal.variants[0].option1);
          ngalFixSelection();
          ngal.ready = true;
          ngalReadySubs.forEach(function (fn) { try { fn(); } catch (e) {} });
          notifyAddons();
        })
        .catch(function () { /* outside the US, or unreadable: no row at all */ });
    } catch (e) { /* same */ }
  }());

  (function loadHelmetAvailability() {
    try {
      fetch("/products/" + HELMET_HANDLE + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.variants) return;
          var map = {};
          j.variants.forEach(function (v) { map[String(v.id)] = !!v.available; });
          var vm = noVented(j); Object.keys(vm).forEach(function (k) { VARIANTS["addon-helmet-" + k.toLowerCase()] = vm[k]; });
          helmetAvail = map;
          helmetFixSelection();
          notifyAddons();
          helmetAvailSubs.forEach(function (fn) { try { fn(); } catch (e) {} });
        })
        .catch(function () { /* unknown stays unknown: nothing is greyed */ });
    } catch (e) { /* same */ }
  }());

  /* Class strings copied verbatim from the React source so the rendered
     markup is byte-identical to the live app in every state. */
  var CLS = {
    housingBase: "flex-1 mono text-[12px] font-bold tracking-[0.14em] uppercase px-3 py-2 rounded-full border transition-colors ",
    on: "border-accent bg-accent/15 text-accent",
    off: "border-transparent bg-background/30 text-muted-foreground hover:border-accent/40 hover:text-foreground",
    oos: "border-transparent bg-background/20 text-muted-foreground/50 line-through cursor-not-allowed",
    fomBase: "mono text-[11px] font-bold tracking-[0.12em] uppercase px-2 py-2 rounded-full border transition-colors ",
    segOn: "mono text-[10px] tracking-[0.14em] uppercase px-2 py-1 border transition-colors border-accent text-accent bg-accent/10",
    segOff: "mono text-[10px] tracking-[0.14em] uppercase px-2 py-1 border transition-colors border-border text-muted-foreground hover:border-border-bright hover:text-foreground"
  };

  /* ---------------------------------------------------------------------------
     3. Buy box , bind + render
     ------------------------------------------------------------------------ */
  function initBuyBox() {
    var grid = $("#bundles .grid");
    if (!grid) return;
    var cards = $$(":scope > div", grid);

    cards.forEach(function (card, idx) {
      var b = BUNDLES[idx];
      if (!b) return;

      var state = { housing: "STANDARD", fom: b.defaultFom };
      /* START: the first card opens where the buy column opens (see columnData). */
      if (b.kitId === "no-pvs14") {
        var cd = columnData();
        var st = cd && cd.start;
        if (st && st.kit === "base" && (st.housing === "STANDARD" || st.housing === "PRO") &&
            b.fomOptions.indexOf(st.fom) >= 0 && !isOutOfStock(b, st.fom, st.housing)) {
          state.housing = st.housing;
          state.fom = st.fom;
        }
      }

      /* --- locate the parts of the card we mutate --------------------------- */
      var labels = $$(".mono.font-bold.mb-1", card);
      var housingBlock = null, fomBlock = null;
      labels.forEach(function (l) {
        var t = (l.textContent || "").trim();
        if (t === "HOUSING") housingBlock = l.parentElement;
        if (t === "FOM (CLARITY)") fomBlock = l.parentElement;
      });

      var kitImg = $('img[alt$="kit contents"]', card);
      var priceRow = $("div.flex.w-full.min-w-0.items-baseline", card);
      var compareEl = priceRow ? priceRow.children[0] : null;
      var totalEl = priceRow ? priceRow.children[1] : null;
      var ctaBtn = $("button.btn-primary", card);
      var imgBtn = $('button[aria-label^="Show add to cart"]', card);
      var atcOverlay = imgBtn ? $('span[role="button"]', imgBtn) : null;
      var addonRow = $('[aria-label="View GEN II FAST SF VENTED HELMET details"]', card);
      var addonHeader = $(".flex.items-baseline.justify-between.mb-3", card);

      /* --- housing --------------------------------------------------------- */
      if (housingBlock && b.hasHousing) {
        var hBtns = $$("button", housingBlock);
        hBtns.forEach(function (btn, i) {
          btn.addEventListener("click", function () {
            var h = i === 0 ? "STANDARD" : "PRO";
            if (isOutOfStock(b, state.fom, h)) state.fom = "1400-1550";
            state.housing = h;
            render(true);
          });
        });
      }

      /* --- FOM ------------------------------------------------------------- */
      if (fomBlock) {
        $$("button", fomBlock).forEach(function (btn, i) {
          var f = b.fomOptions[i];
          btn.addEventListener("click", function () {
            if (isOutOfStock(b, f, state.housing)) return;
            state.fom = f;
            render(false);
          });
        });
      }

      /* --- kit image click reveals the ADD TO CART overlay for 3s ----------- */
      var atcTimer = null;
      if (imgBtn && atcOverlay) {
        imgBtn.addEventListener("click", function () {
          atcOverlay.classList.remove("opacity-0", "pointer-events-none");
          atcOverlay.classList.add("opacity-100");
          if (atcTimer) clearTimeout(atcTimer);
          atcTimer = setTimeout(function () {
            atcOverlay.classList.remove("opacity-100");
            atcOverlay.classList.add("opacity-0", "pointer-events-none");
          }, 3000);
        });
      }

      /* --- heat-bridge inline demo video opens the expanded player ---------- */
      var heatThumb = $('[aria-label="Expand merged eyecam POV video"]', card);
      if (heatThumb) {
        heatThumb.addEventListener("click", function (e) {
          e.stopPropagation();
          openHeatVideo();
        });
      }

      /* --- add-on row ------------------------------------------------------ */
      if (addonRow) {
        var toggleBtn = $('button[role="switch"]', addonRow);
        var knob = toggleBtn ? toggleBtn.firstElementChild : null;
        var rowImg = $("img", addonRow);
        var textCol = addonRow.lastElementChild;
        var titleSpan = textCol ? textCol.querySelector("span") : null;
        var priceSpan = titleSpan ? titleSpan.nextElementSibling : null;
        var subP = textCol ? textCol.querySelector("p") : null;

        addonRow.addEventListener("click", function () { openHelmetDialog(); });
        addonRow.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openHelmetDialog(); }
        });
        if (toggleBtn) {
          toggleBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            addons.helmet.selected = !addons.helmet.selected;
            notifyAddons();
          });
        }

        var renderAddonRow = function () {
          var none = helmetNoneLeft();
          addonRow.style.display = none ? "none" : "";
          if (none) addons.helmet.selected = false;
          var sel = addons.helmet.selected;
          if (toggleBtn) {
            toggleBtn.setAttribute("aria-checked", sel ? "true" : "false");
            toggleBtn.className = "mt-0.5 relative shrink-0 w-10 h-5 rounded-full border transition-colors " +
              (sel ? "border-accent bg-accent/30" : "border-border-bright bg-background/60 hover:border-accent");
          }
          if (knob) {
            knob.className = "absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full transition-all " +
              (sel ? "left-[calc(100%-1.125rem)] bg-accent shadow-[0_0_8px_hsl(var(--accent)/0.7)]" : "left-[3px] bg-muted-foreground");
          }
          if (rowImg) rowImg.src = helmetImage();
          if (titleSpan) {
            titleSpan.className = "mono text-[12px] tracking-[0.1em] uppercase break-words min-w-0 " +
              (sel ? "text-accent" : "text-foreground");
          }
          if (priceSpan) {
            priceSpan.className = "mono text-[12px] tracking-[0.06em] shrink-0 " +
              (sel ? "text-accent" : "text-muted-foreground");
          }

          // Option segs only exist while the add-on is selected.
          var opts = textCol ? textCol.querySelector("[data-no-options]") : null;
          if (sel && !opts && subP) {
            opts = el("div", "mt-2 flex flex-wrap items-center gap-1.5");
            opts.setAttribute("data-no-options", "");
            opts.addEventListener("click", function (e) { e.stopPropagation(); });
            ["BLK", "TAN", "RG"].forEach(function (c) {
              var s = el("button", CLS.segOff, c);
              s.type = "button";
              s.setAttribute("data-color", c);
              s.addEventListener("click", function (e) {
                e.stopPropagation();
                if (!helmetColorAvailable(c)) return;
                addons.helmet.color = c;
                /* a colour with no stock in the chosen size moves the size */
                if (!helmetAvailable(c, addons.helmet.size)) {
                  var alt = addons.helmet.size === "M" ? "L" : "M";
                  if (helmetAvailable(c, alt)) addons.helmet.size = alt;
                }
                notifyAddons();
              });
              opts.appendChild(s);
            });
            opts.appendChild(el("span", "mx-1 text-muted-foreground-dim", "\u00b7"));
            ["M", "L"].forEach(function (sz) {
              var s = el("button", CLS.segOff, sz);
              s.type = "button";
              s.setAttribute("data-size", sz);
              s.setAttribute("data-size-label", sz);
              s.addEventListener("click", function (e) {
                e.stopPropagation();
                /* a sold out size is not selectable */
                if (!helmetSizeAvailable(sz) || !helmetAvailable(addons.helmet.color, sz)) return;
                addons.helmet.size = sz;
                notifyAddons();
              });
              opts.appendChild(s);
            });
            subP.parentNode.appendChild(opts);
          } else if (!sel && opts) {
            opts.parentNode.removeChild(opts);
          }
          if (opts) helmetPaintOpts(opts);

          /* The add on subtotal chip in the section header. NGAL-UPSELLS-2:
             it now counts the helmet AND the NGAL, so a shopper who ticks only
             the NGAL still sees a chip, and one who ticks both sees the sum. */
          if (addonHeader) {
            var addSum = (sel ? HELMET_PRICE : 0) +
              (ngal.selected && !ngalPickBlocked() ? ngalPrice() : 0);
            var tot = addonHeader.querySelector("[data-no-addons-total]");
            if (addSum > 0 && !tot) {
              tot = el("div", "mono text-[10px] tracking-[0.14em] text-accent", "+" + fmt(addSum));
              tot.setAttribute("data-no-addons-total", "");
              addonHeader.appendChild(tot);
            } else if (addSum <= 0 && tot) {
              tot.parentNode.removeChild(tot);
            } else if (tot) {
              tot.textContent = "+" + fmt(addSum);
            }
          }
        };
        /* NGAL-UPSELLS-2: the NGAL row is built into this card group once the
           product feed answers, and repainted with the helmet row beside it. A
           shopper outside the US never gets a feed, so no row is ever built. */
        var ngalRow = null;
        var ngalGroup = addonRow.parentNode;
        function ngalEnsure() {
          if (!ngal.ready) return;
          if (!ngalRow) ngalRow = ngalBuildRow(ngalGroup);
          ngalPaintRow(ngalRow);
        }
        ngalReadySubs.push(function () { ngalEnsure(); render(false); });
        addonSubscribers.push(function () { renderAddonRow(); ngalEnsure(); render(false); });
        renderAddonRow();
        ngalEnsure();
      }

      /* --- add to cart ------------------------------------------------------ */
      if (ctaBtn) {
        ctaBtn.addEventListener("click", function () {
          var id = VARIANTS[b.variantKey(state.housing, state.fom)];
          if (!id) return;
          var items = [{
            id: Number(id),
            quantity: 1,
            properties: b.hasHousing ? { Housing: state.housing, FOM: state.fom } : { FOM: state.fom }
          }];
          if (addons.helmet.selected && !helmetPickBlocked()) {
            var hid = VARIANTS[helmetKey(addons.helmet.color, addons.helmet.size)];
            if (hid) items.push({ id: Number(hid), quantity: 1 });
          }
          /* NGAL-UPSELLS-2: the NGAL rides in the SAME single /cart/add.js call,
             and a sold out colour can never reach it. */
          if (ngal.selected && !ngalPickBlocked()) {
            var nv = ngalVariant();
            if (nv && nv.id) {
              items.push({ id: Number(nv.id), quantity: 1, properties: { Color: String(nv.option1) } });
            }
          }
          ctaBtn.setAttribute("disabled", "disabled");
          addToCart(items, function () { ctaBtn.removeAttribute("disabled"); });
        });
      }

      /* --- full card render ------------------------------------------------- */
      function render(housingChanged) {
        var h = state.housing, f = state.fom;
        var isPro = b.hasHousing && h === "PRO";

        if (housingBlock && b.hasHousing) {
          var p = housingBlock.querySelector("p");
          if (p) p.textContent = HOUSING_EXPLAINER[h];
          var hBtns2 = $$("button", housingBlock);
          hBtns2.forEach(function (btn, i) {
            var active = (i === 0) === (h === "STANDARD");
            btn.setAttribute("aria-pressed", active ? "true" : "false");
            btn.className = CLS.housingBase + (active ? CLS.on : CLS.off);
            var span = btn.querySelector("span");
            if (span) span.className = active ? "text-accent/70" : "text-muted-foreground/70";
          });
        }

        if (fomBlock) {
          var fp = fomBlock.querySelector("p");
          if (fp) fp.textContent = FOM_EXPLAINER[f];
          var widthCls = b.kitId !== "no-pvs31-pro" ? "flex-1 basis-[calc(50%-4px)] " : "flex-1 ";
          $$("button", fomBlock).forEach(function (btn, i) {
            var key = b.fomOptions[i];
            var oos = isOutOfStock(b, key, h);
            var active = key === f;
            btn.setAttribute("aria-pressed", active ? "true" : "false");
            btn.setAttribute("aria-disabled", oos ? "true" : "false");
            btn.disabled = oos;
            btn.title = oos ? "Out of stock" : "";
            btn.className = CLS.fomBase + widthCls + (oos ? CLS.oos : active ? CLS.on : CLS.off);
            var span = btn.querySelector("span");
            if (span) {
              /* The label, not only the colour. A pill that comes back in
                 stock must stop saying SOLD OUT, and one that goes out must
                 start. Before this, the words were whatever the static
                 export baked in. */
              span.textContent = oos ? "SOLD OUT" : "+$" + fomUp(b, key);
              span.className = oos ? "text-warning/80 no-underline" : active ? "text-accent/70" : "text-muted-foreground/70";
            }
          });
        }

        if (kitImg && b.imagePro && housingChanged) {
          kitImg.src = isPro ? b.imagePro : b.image;
        }

        var kitPrice = kitPriceOf(b, h, f);
        /* NGAL-UPSELLS-2: the NGAL joins the same add on subtotal, priced from
           the variant the feed returned rather than from any constant. */
        var addOnsTotal = (addons.helmet.selected ? HELMET_PRICE : 0) +
          (ngal.selected && !ngalPickBlocked() ? ngalPrice() : 0);
        var grand = kitPrice + addOnsTotal;
        var compareKey = b.hasHousing ? h + "-" + f : f;
        if (compareEl) compareEl.textContent = b.compareAt[compareKey] != null ? fmt(b.compareAt[compareKey]) : "";
        if (totalEl) totalEl.textContent = fmt(grand);

        if (ctaBtn) {
          var base = isPro && b.ctaPro ? b.ctaPro : b.cta;
          ctaBtn.textContent = (addOnsTotal > 0
            ? base + " + Add-ons, " + fmt(grand)
            : base + ", " + fmt(kitPrice)) + " \u2192";
        }
      }

      render(state.housing !== "STANDARD");
    });
  }

  /* ---------------------------------------------------------------------------
     4. Modals (replaces Radix Dialog)
     ------------------------------------------------------------------------ */
  var modalHost = el("div");
  ROOT.appendChild(modalHost);
  var openModal = null;

  function closeModal() {
    if (!openModal) return;
    openModal.parentNode.removeChild(openModal);
    openModal = null;
    document.documentElement.classList.remove("no-pvs14-modal-open");
    document.body.classList.remove("no-pvs14-modal-open");
  }

  function showModal(panelClass, panelStyle, innerHTML) {
    closeModal();
    var root = el("div", "no-modal-root");
    root.setAttribute("data-open", "true");
    var overlay = el("div", "no-modal-overlay");
    overlay.addEventListener("click", closeModal);
    var panel = el("div", "no-modal-panel " + (panelClass || ""), innerHTML);
    if (panelStyle) panel.setAttribute("style", panel.getAttribute("style") ? panel.getAttribute("style") + ";" + panelStyle : panelStyle);
    var close = el("button", "no-modal-close", "\u2715");
    close.type = "button";
    close.setAttribute("aria-label", "Close");
    close.addEventListener("click", closeModal);
    panel.appendChild(close);
    root.appendChild(overlay);
    root.appendChild(panel);
    modalHost.appendChild(root);
    openModal = root;
    document.documentElement.classList.add("no-pvs14-modal-open");
    document.body.classList.add("no-pvs14-modal-open");
    return panel;
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });

  /* --- image lightbox (head-to-head NV views) ----------------------------- */
  function openImageLightbox(src, caption) {
    showModal(
      "border-0 bg-transparent backdrop-blur-xl shadow-none p-3 text-foreground gap-4",
      "max-width:42rem;width:calc(100% - 3rem)",
      '<img src="' + src + '" alt="' + caption + ' enlarged" class="w-full h-auto object-contain rounded-sm">' +
      '<div class="mono text-[11px] tracking-[0.16em] uppercase text-foreground text-center pb-2">' + caption + "</div>"
    );
  }

  /* --- heat bridge merged eyecam video ------------------------------------ */
  var HEAT_VIDEO = CDN + "/__l5e/assets-v1/7652624f-3e61-4a64-9f45-d88c2938d9d1/pvs14-heat-bridge-demo.mp4";
  function openHeatVideo() {
    showModal(
      "border-0 bg-transparent backdrop-blur-xl shadow-none p-3 text-foreground gap-4",
      "max-width:42rem;width:calc(100% - 3rem)",
      '<div class="rounded-md overflow-hidden bg-white/5 backdrop-blur-md shadow-[inset_0_1px_0_hsl(0_0%_100%/0.15)]">' +
      '<video src="' + HEAT_VIDEO + '" autoplay loop muted playsinline class="block w-full h-auto"></video></div>' +
      '<div class="mono text-[11px] tracking-[0.16em] uppercase text-foreground text-center pt-2 pb-1">Merged Eyecam POV, Heat Bridge</div>'
    );
  }

  /* --- Gen II helmet add-on details --------------------------------------- */
  var HELMET_DETAILS = {
    eyebrow: "NEW \u00b7 GEN II",
    title: "NIGHT OPERATORS GEN II FAST SF VENTED HELMET",
    originalPrice: "$299.95",
    price: "$149.95",
    optionLabel: "SIZE",
    bullets: [
      "NEW NVG Shroud and ARC rail design, sturdier accessory mounting, accepts comtacs and counterweights.",
      "Memory-foam internal padding for all-day comfort.",
      "Two sizes (M and L), not one-size-fits-most.",
      "Lightweight composite shell with breathable vent design.",
      "Improved blunt-force impact protection vs. Gen I (non-ballistic)."
    ],
    cta: "+ ADD HELMET, $149.95"
  };

  function openHelmetDialog() {
    var d = HELMET_DETAILS;
    var panel = showModal(
      "border-0 border-l-[3px] border-l-accent p-0 overflow-hidden backdrop-blur-xl " +
      "shadow-[0_20px_60px_-10px_hsl(0_0%_0%/0.7),inset_0_1px_0_hsl(var(--accent)/0.08)]",
      "max-width:640px;width:calc(100% - 1.5rem);" +
      "background:linear-gradient(135deg, hsl(0 0% 6% / 0.88) 0%, hsl(0 0% 4% / 0.92) 50%, hsl(152 30% 5% / 0.9) 100%);" +
      "max-height:calc(100svh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - 2rem)",
      '<div class="flex flex-col min-h-0 overflow-y-auto" data-helmet-body>' +
        '<div class="px-5 pt-5 sm:px-7 sm:pt-7 pb-1">' +
          '<div class="mono text-[10px] tracking-[0.18em] uppercase text-accent font-bold mb-1.5">' + d.eyebrow + "</div>" +
          '<h3 class="heading-display text-[clamp(16px,2.4vw,24px)] leading-tight text-foreground pr-8">' + d.title + "</h3>" +
        "</div>" +
        '<div class="relative mt-3 aspect-[16/9] sm:aspect-[4/3] flex items-center justify-center text-center overflow-hidden mx-0 px-0 py-3 sm:py-5">' +
          '<div class="relative w-full h-full overflow-hidden flex items-center justify-center">' +
            '<img data-helmet-img src="' + helmetImage() + '" alt="' + d.title + '" decoding="async" ' +
            'class="absolute inset-0 w-full h-full object-contain transition-opacity duration-500 ease-in-out opacity-100">' +
          "</div>" +
        "</div>" +
        '<div class="px-5 sm:px-7 pt-3 sm:pt-5 flex items-baseline gap-3">' +
          '<span class="mono text-[12px] sm:text-[14px] text-muted-foreground line-through">' + d.originalPrice + "</span>" +
          '<span class="heading-display text-[clamp(20px,3vw,30px)] leading-none text-accent drop-shadow-[0_0_8px_hsl(var(--accent)/0.5)]">' + d.price + "</span>" +
        "</div>" +
        '<div class="px-5 sm:px-7 pt-3 flex items-center gap-3">' +
          '<span class="mono text-[10px] tracking-[0.16em] uppercase text-muted-foreground">' + d.optionLabel + ":</span>" +
          '<div class="flex gap-1.5" data-helmet-opts></div>' +
        "</div>" +
        '<ul class="px-5 sm:px-7 pt-4 pb-2 space-y-2">' +
          d.bullets.map(function (b) {
            return '<li class="flex items-start gap-3 text-[13px] sm:text-[14px] leading-[1.45] text-muted-foreground">' +
              CHECK_SVG + "<span>" + b + "</span></li>";
          }).join("") +
        "</ul>" +
        '<div class="px-5 sm:px-7 py-4 sm:py-6">' +
          '<button type="button" data-helmet-cta class="w-full mono text-[12px] tracking-[0.14em] uppercase font-bold py-3 border transition-colors"></button>' +
          '<p class="mt-3 text-[12px] leading-[1.5] text-muted-foreground italic text-center">Adds to your selected kit at checkout. Toggle off any time.</p>' +
        "</div>" +
      "</div>"
    );

    var opts = $("[data-helmet-opts]", panel);
    ["BLK", "TAN", "RG"].forEach(function (c) {
      var s = el("button", CLS.segOff, c);
      s.type = "button";
      s.setAttribute("data-color", c);
      s.addEventListener("click", function (e) {
        e.stopPropagation();
        addons.helmet.color = c;
        notifyAddons();
        paint();
      });
      opts.appendChild(s);
    });
    opts.appendChild(el("span", "mx-1 text-muted-foreground-dim", "\u00b7"));
    ["M", "L"].forEach(function (sz) {
      var s = el("button", CLS.segOff, sz);
      s.type = "button";
      s.setAttribute("data-size", sz);
      s.addEventListener("click", function (e) {
        e.stopPropagation();
        addons.helmet.size = sz;
        notifyAddons();
        paint();
      });
      opts.appendChild(s);
    });

    var cta = $("[data-helmet-cta]", panel);
    cta.addEventListener("click", function () {
      if (helmetPickBlocked()) return;
      addons.helmet.selected = !addons.helmet.selected;
      notifyAddons();
      paint();
    });

    function paint() {
      helmetPaintOpts(opts);
      var img = $("[data-helmet-img]", panel);
      if (img) img.src = helmetImage();
      /* the add button cannot commit a sold out size */
      var blocked = helmetPickBlocked();
      cta.disabled = blocked;
      cta.setAttribute("aria-disabled", blocked ? "true" : "false");
      cta.className = "w-full mono text-[12px] tracking-[0.14em] uppercase font-bold py-3 border transition-colors " +
        (blocked ? "border-border text-muted-foreground/60 cursor-not-allowed"
          : (addons.helmet.selected ? "border-accent bg-accent text-accent-foreground" : "border-accent text-accent hover:bg-accent/10"));
      cta.textContent = blocked ? "SOLD OUT IN THIS SIZE"
        : (addons.helmet.selected ? "\u2713 ADDED, " + d.price : d.cta);
    }
    helmetAvailSubs.push(function () { if (panel && panel.isConnected) paint(); });
    paint();
  }

  /* --- spec sheet zoom / pan ----------------------------------------------- */
  function openSpecZoom(src) {
    var scale = 1, pos = { x: 0, y: 0 }, drag = null;
    var panel = showModal(
      "p-0 bg-background/95 border border-border overflow-hidden",
      "max-width:min(900px, 95vw)",
      '<div data-zoom-stage class="relative w-full overflow-hidden bg-black select-none" style="height:min(80vh,80svh);cursor:zoom-in">' +
        '<img data-zoom-img src="' + src + '" alt="Factory QC spec sheet, zoom view" draggable="false" ' +
        'class="absolute top-1/2 left-1/2 max-w-none w-auto h-full pointer-events-none">' +
        '<div class="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-background/70 backdrop-blur-md border border-border rounded-full px-2 py-1.5">' +
          '<button type="button" data-zoom="-" class="p-1.5 text-foreground hover:text-accent mono text-[14px] leading-none w-7" aria-label="Zoom out">\u2212</button>' +
          '<span data-zoom-label class="mono text-[11px] tracking-[0.1em] text-muted-foreground tabular-nums w-10 text-center">100%</span>' +
          '<button type="button" data-zoom="+" class="p-1.5 text-foreground hover:text-accent mono text-[14px] leading-none w-7" aria-label="Zoom in">+</button>' +
          '<button type="button" data-zoom="0" class="p-1.5 text-foreground hover:text-accent mono text-[12px] leading-none" aria-label="Reset zoom">\u21ba</button>' +
        "</div>" +
      "</div>"
    );

    var stage = $("[data-zoom-stage]", panel);
    var img = $("[data-zoom-img]", panel);
    var label = $("[data-zoom-label]", panel);

    function apply() {
      img.style.transform = "translate(-50%, -50%) translate(" + pos.x + "px, " + pos.y + "px) scale(" + scale + ")";
      img.style.transformOrigin = "center center";
      img.style.transition = drag ? "none" : "transform 0.15s ease-out";
      stage.style.cursor = scale > 1 ? (drag ? "grabbing" : "grab") : "zoom-in";
      label.textContent = Math.round(scale * 100) + "%";
    }
    function setScale(s) { scale = Math.max(1, Math.min(6, +s.toFixed(2))); if (scale === 1) pos = { x: 0, y: 0 }; apply(); }

    stage.addEventListener("wheel", function (e) {
      e.preventDefault();
      setScale(scale + (e.deltaY < 0 ? 0.25 : -0.25));
    }, { passive: false });
    stage.addEventListener("mousedown", function (e) { drag = { x: e.clientX - pos.x, y: e.clientY - pos.y }; apply(); });
    stage.addEventListener("mousemove", function (e) {
      if (!drag) return;
      pos = { x: e.clientX - drag.x, y: e.clientY - drag.y };
      apply();
    });
    stage.addEventListener("mouseup", function () { drag = null; apply(); });
    stage.addEventListener("mouseleave", function () { drag = null; apply(); });
    stage.addEventListener("dblclick", function () { setScale(scale >= 3 ? 1 : scale + 1); });

    var touch = null;
    stage.addEventListener("touchstart", function (e) {
      if (e.touches.length === 1) touch = { x: e.touches[0].clientX - pos.x, y: e.touches[0].clientY - pos.y };
    }, { passive: true });
    stage.addEventListener("touchmove", function (e) {
      if (!touch || e.touches.length !== 1 || scale <= 1) return;
      pos = { x: e.touches[0].clientX - touch.x, y: e.touches[0].clientY - touch.y };
      apply();
    }, { passive: true });
    stage.addEventListener("touchend", function () { touch = null; });

    $$("[data-zoom]", panel).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var k = btn.getAttribute("data-zoom");
        if (k === "+") setScale(scale + 0.5);
        else if (k === "-") setScale(scale - 0.5);
        else { scale = 1; pos = { x: 0, y: 0 }; apply(); }
      });
    });

    apply();
  }

  function initModalTriggers() {
    // Head-to-head "tap to enlarge" NV circles.
    $$('button[aria-label^="Expand "][aria-label$="tap to enlarge"]').forEach(function (btn) {
      var img = btn.querySelector("img");
      if (!img) return;
      var label = btn.getAttribute("aria-label") || "";
      var brand = label.replace(/^Expand\s+/, "").replace(/\s+night vision view.*$/, "");
      btn.addEventListener("click", function () { openImageLightbox(img.src, brand + ", NV VIEW"); });
    });

    // Spec sheet zoom.
    var specBtn = $('button[aria-label="Open factory QC spec sheet in zoom view"]');
    if (specBtn) {
      var specImg = specBtn.querySelector("img");
      specBtn.addEventListener("click", function () { if (specImg) openSpecZoom(specImg.src); });
    }
  }

  /* ---------------------------------------------------------------------------
     5. Accordions and expanders
     ------------------------------------------------------------------------ */
  function initFaq() {
    var faq = $("#faq");
    if (!faq) return;
    var rows = $$(".border-b.border-border-bright", faq);
    var open = 0;
    var panels = rows.map(function (row) {
      return { btn: row.querySelector("button"), body: row.querySelector("button + div"), plus: row.querySelector("button span:last-child") };
    }).filter(function (p) { return p.btn && p.body; });

    function paint() {
      panels.forEach(function (p, i) {
        var isOpen = open === i;
        p.body.className = "overflow-hidden transition-all duration-300 text-muted-foreground text-[17px] leading-[1.65] px-5 md:px-6 " +
          (isOpen ? "max-h-[1400px] pb-7" : "max-h-0");
        if (p.plus) {
          p.plus.className = "mono text-2xl text-accent flex-shrink-0 transition-transform duration-200 " + (isOpen ? "rotate-45" : "");
        }
      });
    }
    panels.forEach(function (p, i) {
      p.btn.addEventListener("click", function () { open = open === i ? null : i; paint(); });
    });
    paint();
  }

  function initViperExpand() {
    var section = $("#viper-vs-pvs14");
    if (!section) return;
    var btn = section.querySelector('button[aria-controls="viper-vs-pvs14"]');
    var body = section.querySelector(".relative.overflow-hidden.transition-\\[max-height\\]") ||
      section.querySelector('[class*="transition-[max-height]"]');
    if (!btn || !body) return;
    var fade = body.querySelector(".pointer-events-none.absolute.inset-x-0.bottom-0");
    var chevron = btn.querySelector("svg");
    var open = false;
    function paint() {
      body.className = body.className.replace(/max-h-\[\d+px\]/, open ? "max-h-[4000px]" : "max-h-[180px]");
      if (!/max-h-\[/.test(body.className)) body.className += open ? " max-h-[4000px]" : " max-h-[180px]";
      if (fade) fade.style.display = open ? "none" : "";
      if (chevron) chevron.classList.toggle("rotate-180", open);
      btn.childNodes[0].nodeValue = open ? "Collapse" : "Expand Comparison";
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    }
    btn.addEventListener("click", function () { open = !open; paint(); });
    paint();
  }

  function initLegitStrips() {
    var section = $("#legit");
    if (!section) return;
    var STRIPS = [
      {
        title: "DEALER MARGIN", amount: "+$200",
        body: "Every layer of the AGM/ATN/Bering distribution chain (OpticsPlanet, B&H, regional reps, retail storefronts) takes 25-40% margin. Our chain is one layer: us to you."
      },
      {
        title: "INVENTORY FINANCING", amount: "+$100",
        body: "Distributors finance thousands of warehoused units into their wholesale pricing. We assemble in small batches. Less inventory. Less financing cost. That gap returns to you."
      },
      {
        title: "MOUNT + J-ARM MARKUP", amount: "+$300",
        body: "AGM and ATN sell the tube alone. G24 mount + J-arm are separate purchases, typically $150-$400 extra. We include both in the box at our cost: $300+ of value the dealer stack hides."
      }
    ];
    var btns = $$("button.border-destructive", section);
    if (!btns.length) return;
    var host = btns[0].closest(".mx-auto") || btns[0].parentElement.parentElement.parentElement;
    var active = null;
    var panel = null;

    function paint() {
      btns.forEach(function (b, i) {
        var on = active === i;
        b.setAttribute("aria-expanded", on ? "true" : "false");
        b.className = b.className
          .replace(/bg-destructive\/(10|20)( hover:bg-destructive\/20)?/, on ? "bg-destructive/20" : "bg-destructive/10 hover:bg-destructive/20");
      });
      if (panel) { panel.parentNode.removeChild(panel); panel = null; }
      if (active == null) return;
      var s = STRIPS[active];
      panel = el("div", "mt-4 bg-background/20 backdrop-blur-md border-l-[3px] border-l-accent p-5 sm:p-6",
        '<div class="flex items-baseline justify-between gap-3 mb-2 flex-wrap">' +
          '<div class="heading-display text-[13px] sm:text-[14px] tracking-[0.16em] uppercase text-foreground">' + s.title + "</div>" +
          '<div class="heading-display text-[13px] sm:text-[14px] tracking-[0.16em] uppercase text-accent">STRIPS ' + s.amount + "</div>" +
        "</div>" +
        '<p class="text-[15px] sm:text-[16px] leading-[1.6] text-muted-foreground">' + s.body + "</p>");
      panel.setAttribute("aria-live", "polite");
      host.appendChild(panel);
    }

    btns.forEach(function (b, i) {
      b.addEventListener("click", function () { active = active === i ? null : i; paint(); });
      b.addEventListener("pointerenter", function (e) { if (e.pointerType !== "touch") { active = i; paint(); } });
      b.addEventListener("pointerleave", function (e) { if (e.pointerType !== "touch" && active === i) { active = null; paint(); } });
    });
  }

  /* ---------------------------------------------------------------------------
     6. Scroll-scrubbed video sections
     ------------------------------------------------------------------------ */
  function sampleTrack(track, t) {
    if (t <= track[0][0]) return { x: track[0][1], y: track[0][2] };
    var last = track[track.length - 1];
    if (t >= last[0]) return { x: last[1], y: last[2] };
    for (var i = 0; i < track.length - 1; i++) {
      var a = track[i], b = track[i + 1];
      if (t >= a[0] && t <= b[0]) {
        var k = (t - a[0]) / (b[0] - a[0]);
        return { x: a[1] + (b[1] - a[1]) * k, y: a[2] + (b[2] - a[2]) * k };
      }
    }
    return { x: track[0][1], y: track[0][2] };
  }

  var DEFAULT_TRACK = [
    [0.0, 0.50, 0.40], [0.18, 0.54, 0.42], [0.26, 0.56, 0.44], [0.34, 0.54, 0.46],
    [0.42, 0.52, 0.47], [0.50, 0.48, 0.48], [0.58, 0.42, 0.49], [0.66, 0.30, 0.50],
    [0.74, 0.24, 0.50], [0.84, 0.22, 0.50], [1.0, 0.20, 0.50]
  ];
  var PRO_TRACK = [
    [0.0, 0.42, 0.50], [0.25, 0.45, 0.45], [0.5, 0.42, 0.50], [0.75, 0.45, 0.52], [1.0, 0.42, 0.50]
  ];
  var G24_TRACK = [
    [0.0, 0.70, 0.26], [0.2, 0.66, 0.32], [0.4, 0.60, 0.40],
    [0.6, 0.54, 0.47], [0.8, 0.48, 0.53], [1.0, 0.44, 0.57]
  ];
  var G24_TRACK_MD = [[0.0, 0.49, 0.56], [0.5, 0.48, 0.62], [1.0, 0.48, 0.66]];
  var TRACK_LEFT = [[0.0, 0.18, 0.50], [0.25, 0.20, 0.48], [0.5, 0.18, 0.50], [0.75, 0.16, 0.52], [1.0, 0.18, 0.50]];
  var TRACK_RIGHT = [[0.0, 0.82, 0.50], [0.25, 0.80, 0.48], [0.5, 0.82, 0.50], [0.75, 0.84, 0.52], [1.0, 0.82, 0.50]];

  /** Pinned (200vh wrapper + sticky stage) scrubber with a tracking callout. */
  function bindPinnedScrub(section, opts) {
    var wrapper = section.querySelector(":scope > div");
    if (!wrapper) return;
    var stage = wrapper.querySelector(":scope > div");
    var video = section.querySelector("video");
    var overlay = stage ? stage.querySelector(".pointer-events-none.absolute.inset-0") : null;
    if (!wrapper || !stage || !video) return;
    var dot = overlay ? overlay.querySelector(".will-change-transform") : null;
    var path = overlay ? overlay.querySelector("path[stroke]") : null;
    var card = overlay ? overlay.querySelector("[data-callout-card]") || overlay.querySelector(":scope > div:last-child") : null;

    var raf = null, targetTime = 0, ready = false;
    var mq = window.matchMedia("(min-width: 768px)");

    function kick() {
      ready = true;
      video.muted = true; video.playsInline = true; /* NO-VIDEO-INLINE-1014 */
      var p = video.play();
      if (p && p.then) p.then(function () { try { video.pause(); } catch (e) {} }).catch(function () {});
      else { try { video.pause(); } catch (e) {} }
      onScroll();
    }
    if (video.readyState >= 2) kick();
    video.addEventListener("loadeddata", kick);

    function tick() {
      raf = null;
      var d = video.duration;
      if (!d || isNaN(d)) return;
      try { video.currentTime = Math.max(0, Math.min(d - 0.001, targetTime)); } catch (e) {}
    }

    function updateCallout(progress) {
      if (!dot || !path || !card) return;
      var r = stage.getBoundingClientRect();
      var vw = video.videoWidth || 720, vh = video.videoHeight || 1280;
      var scale = Math.max(r.width / vw, r.height / vh);
      var dispW = vw * scale, dispH = vh * scale;
      var offX = (r.width - dispW) / 2, offY = (r.height - dispH) / 2;
      var track = (mq.matches && opts.trackMd) ? opts.trackMd : opts.track;
      var pt = sampleTrack(track, progress);
      var dotX = offX + pt.x * dispW, dotY = offY + pt.y * dispH;
      dot.style.transform = "translate3d(" + dotX + "px," + dotY + "px,0) translate(-50%,-50%)";
      var cr = card.getBoundingClientRect();
      var cx = cr.left - r.left;
      var cy = (opts.leaderAnchor === "bottom-left" ? cr.bottom : cr.top) - r.top;
      path.setAttribute("d", "M " + dotX + " " + dotY + " L " + cx + " " + cy);
    }

    function onScroll() {
      if (!ready) return;
      var rect = wrapper.getBoundingClientRect();
      var dist = wrapper.offsetHeight - window.innerHeight;
      if (dist <= 0) return;
      var progress = Math.max(0, Math.min(1, -rect.top / dist));
      targetTime = progress * (video.duration || 0);
      if (raf == null) raf = requestAnimationFrame(tick);
      updateCallout(progress);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  /** PVS-31 mobile parallax , scrubbed, but starts at a fixed entry frame. */
  function bindPvs31Parallax(wrapper) {
    var video = wrapper.querySelector("video");
    if (!video) return;
    var ENTRY = 0.42;
    var raf = null, targetTime = ENTRY, ready = false;

    function kick() {
      ready = true;
      try { video.currentTime = ENTRY; } catch (e) {}
      video.muted = true; video.playsInline = true; /* NO-VIDEO-INLINE-1014 */
      var p = video.play();
      if (p && p.then) {
        p.then(function () { video.pause(); try { video.currentTime = ENTRY; } catch (e) {} }).catch(function () {});
      } else { try { video.pause(); } catch (e) {} }
      onScroll();
    }
    if (video.readyState >= 2) kick();
    video.addEventListener("loadeddata", kick);

    function tick() {
      raf = null;
      var d = video.duration;
      if (!d || isNaN(d)) return;
      try { video.currentTime = Math.max(0, Math.min(d - 0.001, targetTime)); } catch (e) {}
    }
    function onScroll() {
      if (!ready) return;
      var rect = wrapper.getBoundingClientRect();
      var dist = wrapper.offsetHeight - window.innerHeight;
      if (dist <= 0) return;
      var progress = Math.max(0, Math.min(1, -rect.top / dist));
      targetTime = ENTRY + progress * Math.max(0, (video.duration || 0) - ENTRY);
      if (raf == null) raf = requestAnimationFrame(tick);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  /** Desktop combined housings , looping video, leader lines follow playback. */
  function bindCombinedLoop(section) {
    var stage = section.querySelector(":scope > div");
    var video = section.querySelector("video");
    if (!stage || !video) return;
    var paths = $$("path[stroke]", stage);
    var dots = $$(".will-change-transform", stage);
    var cards = $$('[class*="w-[320px]"]', stage);
    if (paths.length < 2 || dots.length < 2 || cards.length < 2) return;

    function pair(track, progress, dot, path, card, side, r, dispW, dispH, offX, offY) {
      var pt = sampleTrack(track, progress);
      var dotX = offX + pt.x * dispW, dotY = offY + pt.y * dispH;
      dot.style.transform = "translate3d(" + dotX + "px," + dotY + "px,0) translate(-50%,-50%)";
      var cr = card.getBoundingClientRect();
      var cx = (side === "left" ? cr.left : cr.right) - r.left;
      var cy = cr.top + cr.height / 2 - r.top;
      path.setAttribute("d", "M " + dotX + " " + dotY + " L " + cx + " " + cy);
    }

    function render() {
      var d = video.duration;
      var progress = d && !isNaN(d) ? (video.currentTime / d) % 1 : 0;
      var r = stage.getBoundingClientRect();
      var vw = video.videoWidth || 1600, vh = video.videoHeight || 864;
      var scale = Math.max(r.width / vw, r.height / vh);
      var dispW = vw * scale, dispH = vh * scale;
      var offX = (r.width - dispW) / 2, offY = (r.height - dispH) / 2;
      pair(TRACK_LEFT, progress, dots[0], paths[0], cards[0], "left", r, dispW, dispH, offX, offY);
      pair(TRACK_RIGHT, progress, dots[1], paths[1], cards[1], "right", r, dispW, dispH, offX, offY);
      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  }

  function initScrubSections() {
    var std = $('section[aria-label="PVS-14 standard housing"]');
    if (std) bindPinnedScrub(std, { track: DEFAULT_TRACK, leaderAnchor: "top-left" });

    var pro = $('section[aria-label="PVS-14 pro housing"]');
    if (pro) bindPinnedScrub(pro, { track: PRO_TRACK, leaderAnchor: "top-left" });

    var g24 = $('section[aria-label="G24 J-arm"]');
    if (g24) bindPinnedScrub(g24, { track: G24_TRACK, trackMd: G24_TRACK_MD, leaderAnchor: "bottom-left" });

    var combined = $('section[aria-label="PVS-14 standard vs. pro housing"]');
    if (combined) bindCombinedLoop(combined);

    var pvs31 = $('section[aria-label="PVS-31 PRO"]');
    if (pvs31) {
      var mobileWrapper = pvs31.querySelector('[class*="h-[240vh]"]');
      if (mobileWrapper) bindPvs31Parallax(mobileWrapper);
    }
  }

  /* ---------------------------------------------------------------------------
     7. Head-to-head mobile NV circle scaling
     ------------------------------------------------------------------------ */
  function initHeadToHeadScale() {
    var section = $("#head-to-head");
    if (!section) return;
    var mql = window.matchMedia("(max-width: 767px)");
    var items = $$('button[aria-label^="Expand "][aria-label$="tap to enlarge"]', section).map(function (nv) {
      return { nv: nv, wrapper: nv.parentElement };
    });
    var raf = 0;

    function update() {
      raf = 0;
      items.forEach(function (it) {
        if (!mql.matches) { it.nv.style.transform = ""; it.nv.style.transformOrigin = ""; return; }
        var rect = it.wrapper.getBoundingClientRect();
        var vh = window.innerHeight;
        var center = rect.top + rect.height / 2;
        var offset = (center - vh / 2) / (vh / 6);
        var t = Math.max(0, Math.min(1, Math.abs(offset)));
        var eased = t * t * (3 - 2 * t);
        var peakBoost = offset < 0 ? 1.1 : 1.15;
        it.nv.style.transformOrigin = "top left";
        it.nv.style.transform = "scale(" + (2 + eased * peakBoost) + ")";
      });
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    if (mql.addEventListener) mql.addEventListener("change", update);
    update();
  }

  /* ---------------------------------------------------------------------------
     8. Video lifecycle , lazy start, pause off-screen, unmute on user play
     ------------------------------------------------------------------------ */
  function initVideos() {
    var scrubbed = [];
    $$("section[aria-label]").forEach(function (s) {
      var l = s.getAttribute("aria-label");
      if (/housing|J-arm|PVS-31 PRO/.test(l)) {
        $$("video", s).forEach(function (v) { scrubbed.push(v); });
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (scrubbed.indexOf(v) !== -1) return; // scrub videos are driven by scroll
        if (entry.isIntersecting) {
          if (v.hasAttribute("controls") && v.dataset.noUserPlayed !== "1") return;
          if (!v.hasAttribute("controls")) v.muted = true; v.playsInline = true; /* NO-VIDEO-INLINE-1014 */
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.2 });

    $$("video").forEach(function (v) {
      v.addEventListener("play", function () {
        v.dataset.noUserPlayed = "1";
        if (v.hasAttribute("controls") && v.muted) v.muted = false;
      });
      io.observe(v);
    });
  }

  /* ---------------------------------------------------------------------------
     9. In-page anchor links , smooth scroll without hijacking the host theme
     ------------------------------------------------------------------------ */
  function initAnchors() {
    ROOT.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !ROOT.contains(a)) return;
      var id = a.getAttribute("href").slice(1);
      if (!id) return;
      var target = document.getElementById(id) || ROOT.querySelector("#" + CSS.escape(id));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  /* ---------------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------------ */
  function boot() {
    initBuyBox();
    initModalTriggers();
    initFaq();
    initViperExpand();
    initLegitStrips();
    initScrubSections();
    initHeadToHeadScale();
    initVideos();
    initAnchors();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
